import React from 'react';
import {createRoot} from "react-dom/client";
import Container from "../../Components/TabContainer";

const tabs = document.getElementById('job-opportunity-tabs');
if (tabs) {
    createRoot(tabs).render(<Container {...(tabs.dataset)} />);
}
